import { isProductionENV } from '../config'
import AnalyticsService from '../services/AnalyticsService'
import * as Sentry from '@sentry/nextjs'

export const GA_TRACKING_ID = 'G-X9LSHWK05K'

const allowAnalytics = isProductionENV && typeof window !== 'undefined'

export const registerGoogleAnalyticsPageView = (url, userID) => {
  if (allowAnalytics) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
      user_id: userID,
    })
  }
}

/**
 * https://developers.google.com/analytics/devguides/collection/gtagjs/events
 * @param {string} action
 * @param {string} category
 * @param {string} label
 * @param {number} value
 */
export const registerGoogleAnalyticsEvent = ({ action, category, label, value }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}

/**
 * Captures an event and send it to the internal analytics API.
 * @param {string} companyUUID - Target company UUID.
 * @param {string} name - Event name. It could be any.
 * @param {string} [resourceUUID] - May be a post, or product UUID.
 * @param {string} [userUUID] - Useful to capture unique events.
 * @returns {Promise<void>}
 */
export const registerInternalAnalyticsEvent = async ({ companyUUID, name, resourceUUID, userUUID }) => {
  const analyticsService = new AnalyticsService()

  if (allowedInternalAnalyticsEventNames.indexOf(name) === -1) {
    Sentry.captureMessage(`Event with name '${name} does not exists.'`, {
      extra: {
        companyUUID,
        name,
        resourceUUID,
        userUUID,
      },
    })
  }

  try {
    await analyticsService.createEvent({ companyUUID, name, resourceUUID, userUUID })
  } catch (e) {
    Sentry.captureException(e, {
      extra: {
        companyUUID,
        name,
        resourceUUID,
        userUUID,
      },
    })
  }
}

const allowedInternalAnalyticsEventNames = [
  'view-company',
  'click-company',
  'view-post',
  'click-contact',
  'view-product',
  'click-product',
]
